/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Send_Tts_Messages_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to send text-to-speech messages by starting a message with /tts. These messages can be heard by anyone focused on the channel." |
*
* @param {Leveling_Perm_Send_Tts_Messages_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_send_tts_messages_hint = /** @type {((inputs?: Leveling_Perm_Send_Tts_Messages_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Send_Tts_Messages_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам отправлять сообщения с озвучиванием текста: для этого сообщение начинают с /tts. Такие сообщения слышат все, у кого открыт этот канал.")
	return /** @type {LocalizedString} */ ("Allows members to send text-to-speech messages by starting a message with /tts. These messages can be heard by anyone focused on the channel.")
});